import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowRight,
  faBars,
  faBellSlash,
  faBell as faBellSolid,
  faBold,
  faCamera,
  faCheck,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCloudDownloadAlt,
  faCode,
  faCog,
  faCogs,
  faColumns,
  faDownload,
  faEllipsisH,
  faEllipsisV,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEyeSlash,
  faFileExport,
  faFilter,
  faGripHorizontal,
  faGripVertical,
  faIndent,
  faItalic,
  faKey,
  faLink,
  faListOl,
  faListUl,
  faLocationArrow,
  faLocationCrosshairs,
  faMapMarkedAlt,
  faOutdent,
  faParagraph,
  faPaperclip,
  faPen,
  faPlus,
  faQuestion,
  faQuoteRight,
  faRemoveFormat,
  faReply,
  faSearch,
  faSearchLocation,
  faSearchPlus,
  faShareAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSortAmountDown,
  faSortAmountUp,
  faStrikethrough,
  faSync,
  faTable,
  faTasks,
  faThumbtack,
  faTimes,
  faTools,
  faTrashRestore,
  faUnderline,
  faUserCog,
  faWrench,
} from '@fortawesome/free-solid-svg-icons'

import {
  faBell,
  faClock,
  faClone,
  faCopy,
  faEdit,
  faEnvelope,
  faEye,
  faFileAlt,
  faFileArchive,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faPlusSquare,
  faQuestionCircle,
  faSave,
  faSquare,
  faTrashAlt,
  faUser,
  faEnvelopeOpen,
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faSort,
  faSortUp,
  faSortDown,
  faSortAmountDown,
  faSortAmountUp,
  faWrench,
  faGripVertical,
  faDownload,
  faFileAlt,
  faFileWord,
  faFilePdf,
  faFilePowerpoint,
  faFileArchive,
  faFileExcel,
  faFileVideo,
  faFileImage,
  faFileExport,
  faEdit,
  faTrashAlt,
  faSearch,
  faSearchPlus,
  faBars,
  faCloudDownloadAlt,
  faTimes,
  faCheck,
  faCheckDouble,
  faBell,
  faClock,
  faSquare,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faQuoteRight,
  faCode,
  faListUl,
  faListOl,
  faOutdent,
  faIndent,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faLink,
  faRemoveFormat,
  faTasks,
  faParagraph,
  faClone,
  faCopy,
  faPlusSquare,
  faTrashRestore,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faShareAlt,
  faEnvelope,
  faEnvelopeOpen,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faExternalLinkAlt,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faEllipsisH,
  faEyeSlash,
  faArrowRight,
  faUserCog,
  faQuestionCircle,
  faFilter,
  faSave,
  faGripHorizontal,
  faUser,
  faCogs,
  faCog,
  faPen,
  faThumbtack,
  faEye,
  faPlus,
  faColumns,
  faSearchLocation,
  faMapMarkedAlt,
  faKey,
  faQuestion,
  faExclamationTriangle,
  faSync,
  faEllipsisV,
  faLocationArrow,
  faTools,
  faExclamationCircle,
  faTable,
  faCamera,
  faBell,
  faBellSolid,
  faBellSlash,
  faLocationCrosshairs,
  faPaperclip,
  faReply,
)
